import { useEffect, useMemo, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import "../../assets/css/dataTable.css";
import { useAuth } from "../../context/AuthContext";
import {
  getLatestRunAt,
  getObjectFilterSOQL,
  getObjectFilterWith,
  getObjectFilterWithout,
  getObjectName,
  getObjectRecords,
  getObjectSelectedFields,
  setObjectDetails,
} from "../../redux/reducers/objectSlice";
import { useAppDispatch, useAppSelector } from "../../redux/stateHooks";
import { getQueryDataWithPost } from "../../services/apiService";
import Filter from "../Filter/filter";
import ListDataRecords from "../ListDataRecords/listDataRecords";
import LoadTable from "../LoadTable/loadTable";
import SaveTable from "../SaveTable/saveTable";
import Settings from "../Settings/settings";
function AppTabItems() {
  const [imageColumns, setImageColumns] = useState([]);
  const { tabname } = useParams();
  const { signOut } = useAuth();
  const objectRecords = useAppSelector(getObjectRecords);
  const objectName = useAppSelector(getObjectName);
  const fields = useAppSelector(getObjectSelectedFields);
  const runat = useAppSelector(getLatestRunAt);
  const soql = useAppSelector(getObjectFilterSOQL);
  const _with = useAppSelector(getObjectFilterWith);
  const _without = useAppSelector(getObjectFilterWithout);
  const dispatch = useAppDispatch();
  const executeQuery = async (query) => {
    let body = {
      soql: query,
      withRelation: _with && _with.length > 0 ? _with : undefined,
      withoutRelation: _without && _without.length > 0 ? _without : undefined,
    };
    try {
      let { data: result } = await getQueryDataWithPost(body);
      dispatch(setObjectDetails({ records: result }));
    } catch (err) {
      toast.error(err?.response?.data?.message || "Something went wrong.");
    }
  };

  const columnDefinitions = useMemo(() => {
    if (objectRecords?.[0]) {
      return Object.keys(objectRecords?.[0]).map((col) => ({
        Header: col,
        accessor: col,
      }));
    } else if (fields) {
      return Object.keys(fields).map((col) => ({
        Header: fields[col],
        accessor: fields[col],
      }));
    }
  }, [fields, objectRecords]);

  useEffect(() => {
    if (fields && fields.length) {
      if (!soql) {
        const selectClause = fields.join(", ");
        const sqlQuery = `SELECT ${selectClause} FROM ${objectName}`;
        executeQuery(sqlQuery);
      } else {
        executeQuery(soql);
      }
    }
  }, [
    runat,
    JSON.stringify(fields),
    soql,
    JSON.stringify(_with),
    JSON.stringify(_without),
  ]);
  return (
    <div className="contentCntr dark-bg">
      <div className="tabBox">
        <ul className="nav nav-tabs">
          <li className="nav-item">
            <Link
              className={`nav-link ${tabname == "loadtable" ? "active" : ""}`}
              to={"/app-tabs-items-component/loadtable"}
            >
              Load Table
            </Link>
          </li>
          <li className="nav-item">
            <Link
              className={`nav-link ${tabname == "savetable" ? "active" : ""}`}
              to={"/app-tabs-items-component/savetable"}
            >
              Save Table
            </Link>
          </li>
          <li className="nav-item">
            <Link
              className={`nav-link ${tabname == "settings" ? "active" : ""}`}
              to={"/app-tabs-items-component/settings"}
            >
              Settings
            </Link>
          </li>
          <li className="nav-item">
            <Link
              className={`nav-link ${tabname == "settings" ? "active" : ""}`}
              to={""}
              onClick={signOut}
            >
              Sign Out
            </Link>
          </li>
        </ul>
      </div>
      {tabname === "loadtable" ? (
        <>
          <div className="tab-pane custom-tabPane overflow-hidden">
            {!!objectRecords ? (
              <>
                <Filter imageColumns={imageColumns} />
                <ListDataRecords
                  title={objectName}
                  columns={columnDefinitions}
                  data={objectRecords}
                  imageColumns={imageColumns}
                  setImageColumns={setImageColumns}
                />
              </>
            ) : (
              <LoadTable />
            )}
          </div>
        </>
      ) : null}
      {tabname === "savetable" ? <SaveTable /> : null}
      {tabname === "settings" ? <Settings /> : null}
    </div>
  );
}

export default AppTabItems;
